// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1o1QE","content":"styles_content__1QQvA"};